import React from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import ValuesFitResults from '../../components/reports/shared/results/values-fit-results';
import PersonalityAcumenResults from '../../components/reports/shared/results/personality-acumen-results';
import ExperienceJudgmentResults from '../../components/reports/shared/results/experience-judgment-results';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import RecommendationsPersonalityTips from '../../components/reports/shared/tips/recommendations-personality-tips';
import { NEW_HIRE_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import CandidateInterviewSummary from '../../components/reports/candidate-profile/candidate-interview-summary';
import CandidateConfidentialPage from '../../components/reports/candidate/candidate-confidential-page';
import { useLocation } from 'react-router-dom';
import { REPORT_TYPE } from '../../utils/constants';
import StaffingInstructionsPage1 from '../../components/reports/candidate/staffing-instructions-page-1';
import StaffingInstructionsPage2 from '../../components/reports/candidate/staffing-instructions-page-2';
import { FeedbackReport } from '../../components/reports/shared/results/feedback-report';

function NewHireManagerReport({ candidate, creatingPdf, reportType = REPORT_TYPE.coaching }) {
  let isRemoteStaffing = false;
  if (reportType === REPORT_TYPE.staffing) {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    isRemoteStaffing = searchParams.get('staffing') === 'remote';
  }

  return (
    <>
      <div className="print-page">
        <CandidateConfidentialPage
          candidate={candidate}
          competencies={true}
          reportType={reportType}
          withDetailedInformation={false}
        />
      </div>
      {reportType === REPORT_TYPE.staffing && (
        <>
          <div className="print-page">
            <StaffingInstructionsPage1 candidate={candidate} remoteStaffing={isRemoteStaffing} />
          </div>
          <div className="print-page">
            <StaffingInstructionsPage2 remoteStaffing={isRemoteStaffing} />
          </div>
        </>
      )}
      <div className="print-page">
        <ReportPdfHeader />
        <ReportHeader candidate={candidate} header="New Hire Manager Report" remoteStaffing={isRemoteStaffing} />
      </div>
      <FeedbackReport candidate={candidate} reportType={REPORT_TYPE.staffing} creatingPdf={creatingPdf} />
      <div className="print-page">
        <PersonalityAcumenResults candidate={candidate} reportType={reportType} remoteStaffing={isRemoteStaffing} />
      </div>
      <div className="print-page">
        <ValuesFitResults candidate={candidate} remoteStaffing={isRemoteStaffing} reportType={reportType} />
      </div>
      <div className="print-page">
        <ExperienceJudgmentResults candidate={candidate} reportType={reportType} />
      </div>
      {candidate.interviewCompetencies?.scores && (
        <div className="print-page">
          <CandidateInterviewSummary candidate={candidate} />
        </div>
      )}
      <div className="print-page">
        <RecommendationsPersonalityTips candidate={candidate} reportType={reportType} />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        topFourMisAligned={true}
        valuesTips={NEW_HIRE_VALUE_TIPS}
        creatingPdf={creatingPdf}
        reportType={reportType}
        remoteStaffing={isRemoteStaffing}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={1} reportType={reportType} />
      </div>
    </>
  );
}

export default NewHireManagerReport;
